<template>
  <div class="web-box-all">
    <ext-header select_menu="9"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">

          <div class="web-user-title">
            <p><i></i>我的弗兰卡 > 积分明细</p>
          </div>

          <div class="web-integral-top">
            <p>积分余额：{{user_integral}}</p>
          </div>

          <div class="web-integral-list">

            <h2>
              <a>日期</a>
              <a>收入/支出</a>
              <a>详细说明</a>
            </h2>

            <p v-for="(vo,index) in list_data" :key="index">
              <a>{{vo.ctime}}</a>
              <a v-if="vo.type_id==1">+{{vo.integral}}</a>
              <a v-else>-{{vo.integral}}</a>
              <a>{{vo.remark}}</a>
            </p>

          </div>

          <div class="web-order-list-page">
            <b-pagination
              v-model="currentPage"
              :total-rows="list_count"
              :per-page="perPage"
              @change="load_page"
              first-number
              last-number
            >
            <template #prev-text><span class="lemon-page">上一页</span></template>
            <template #next-text><span class="lemon-page">下一页</span></template>
            <template #page="{ page, active }">
              <b class="lemon-page-now" v-if="active">{{ page }}</b>
              <i class="lemon-page-line" v-else>{{ page }}</i>
            </template>
            </b-pagination>
          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'

export default {
  name: 'integral',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav
  },
  data () {
    return {
      title: '订单列表',
      now_date: '',
      select_date: [],
      user_integral: 0,
      perPage: 10,
      currentPage: 1,
      list_data: [],
      list_count: 0

    }
  },
  mounted () {
    this.load_user()
    this.load_date()
  },
  methods: {
    select_date_fun (str) {
      this.now_date = str
      this.load_data()
    },
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_integral = ret.data.integral
        }
      })
    },
    load_date () {
      var that = this
      ajax({
        url: '/store/user/integral_date',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.now_date = ret.data['0']
          that.select_date = ret.data
          that.load_data()
        }
      })
    },
    load_page (page) {
      this.currentPage = page
      this.load_data()
    },
    load_data () {
      var that = this
      var page = this.currentPage
      ajax({
        url: '/store/user/integral_bill',
        method: 'post',
        data: {
          uid: getUserId(),
          select_date: '',
          page: page
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.list_count = ret.data.list_count
          that.list_data = ret.data.list_data
        } else {
          that.list_data = []
          that.list_count = 0
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-user-title { width:100%; height:40px; flex-flow:row; align-content:flex-start;}
      .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
      .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}

.web-integral-top { width:100%; height:80px; margin-top:15px; position: relative; border:1px solid #dfdfdf; padding:0px 15px;}
  .web-integral-top p  { width:100%; height:50px; margin-top:15px; padding:0px; line-height:50px; font-size:18px;}

  .web-integral-top h2  {  width:100px; height:30px; position: absolute;  top:15px; right:5px;}

.web-integral-list { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; border:1px solid #dfdfdf; margin-top:15px;}
  .web-integral-list h2 {  width:100%; height:40px; line-height:40px; margin:0px; padding:0px 15px; background: #f5f8fa; flex-flow:row; align-content:flex-start;}
  .web-integral-list h2 a { width:33.333%; height:40px; line-height:40px; font-size:14px; color:#333333;}
  .web-integral-list p { width:100%; height:auto; margin:0px; border-top: 1px solid #efefef; padding:0px 15px; flex-flow:row; align-content:flex-start;}
  .web-integral-list p a { width:33.333%; height:40px; line-height:40px; font-size:14px; color:#333333;}

    .web-order-list-page { width:100%; height:40px; margin-top:20px;}

    .lemon-page { color:#333333; font-size:14px; height:24px; line-height:24px;}
    .lemon-page-now { background: #d81e06 !important; color:#ffffff !important; width:24px; height:24px;}
    .lemon-page-line { color:#333333; font-style: normal;}
</style>
<style>
  .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
</style>



// WEBPACK FOOTER //
// src/pages/store/integral.vue